import { api } from "../lib/api";

export const list = (unreadOnly = false) =>
  api.get("/notifications", { params: { unread_only: unreadOnly } }).then((r) => r.data);

export const markRead = (id) =>
  api.post(`/notifications/${id}/read`).then((r) => r.data);

export const markAllRead = () =>
  api.post("/notifications/read-all").then((r) => r.data);
